import { Component, Input, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { FormArray, FormControl, FormGroup } from '@angular/forms';
import { DataStream } from '@models/data-stream';
import { PartyContact } from '@models/party-contact';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { Observable, Subscription } from 'rxjs';

@Component({
    selector: 'app-data-stream',
    templateUrl: './data-stream.component.html',
    styleUrls: ['./data-stream.component.scss'],
    standalone: false
})
export class DataStreamComponent implements OnInit {

  @Input() dataStream!: DataStream;
  @Input() supplierContact!: PartyContact;
  @Input() viewSetting: string = 'TILE';
  @Input() parentFormGroup!: FormGroup;

  @Input() select: Observable<boolean> = new Observable<boolean>();
  private selectSubscription!: Subscription;

  @ViewChild('contactModal') private modalContent!: TemplateRef<any>;
  private modalRef!: NgbModalRef;

  public newMinDate: Date = new Date();

  constructor(
    private modalService: NgbModal,
  ) {
    this.newMinDate.setDate(this.newMinDate.getDate() - 14);
  }

  ngOnInit(): void {
    this.selectSubscription = this.select.subscribe((select: boolean) => {
      this.selectOrUnselectDataStream(select);
    });
  }

  ngOnDestroy() {
    this.selectSubscription.unsubscribe();
  }

  public showContact(): void {
    this.modalRef = this.modalService.open(this.modalContent)
  }

  public closeContact() {
    this.modalRef.close();
  }

  public dataStreamIdChange(event: any): void {
    this.selectOrUnselectDataStream(event.target?.checked!);
  }

  public get selected(): boolean {
    return this.dataStreamIds.controls.some(x => x.value == this.dataStream.id);
  }

  private get dataStreamIds(): FormArray {
    return <FormArray>this.parentFormGroup.controls['dataStreamIds'];
  }

  public selectOrUnselectDataStream(selected: boolean): void {
    // The form array is the single source of truth for the checkbox state, so only add/remove when needed
    const dataStreamIds = this.dataStreamIds;
    const index = dataStreamIds.controls.findIndex(x => x.value == this.dataStream.id);

    if (selected && index < 0) {
      dataStreamIds.push(new FormControl(this.dataStream.id));
    } else if (!selected && index >= 0) {
      dataStreamIds.removeAt(index);
    }
  }


}
